var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 13C14.447 13 14 13.448 14 14V18C14 18.551 13.552 19 13 19H10V4C10 3.146 9.456 2.383 8.638 2.099L8.342 2H13C13.552 2 14 2.449 14 3V6C14 6.552 14.447 7 15 7C15.553 7 16 6.552 16 6V3C16 1.346 14.654 0 13 0H2.25C2.212 0 2.18 0.017 2.143 0.022C2.095 0.018 2.049 0 2 0C0.897 0 0 0.897 0 2V20C0 20.854 0.544 21.617 1.362 21.901L7.38 23.907C7.584 23.97 7.787 24 8 24C9.103 24 10 23.103 10 22V21H13C14.654 21 16 19.654 16 18V14C16 13.448 15.553 13 15 13Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.707 9.29319L19.707 5.29319C19.421 5.00719 18.991 4.92119 18.617 5.07619C18.244 5.23119 18 5.59619 18 6.00019V9.00019H14C13.448 9.00019 13 9.44819 13 10.0002C13 10.5522 13.448 11.0002 14 11.0002H18V14.0002C18 14.4042 18.244 14.7692 18.617 14.9242C18.991 15.0792 19.421 14.9932 19.707 14.7072L23.707 10.7072C24.098 10.3162 24.098 9.68419 23.707 9.29319Z",
    fill: "#8A8A8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.27cea76b.svg";
export { ForwardRef as ReactComponent };